<script lang="ts">
	import ArrowUp from './arrowUp.svg.svelte';
	interface Props {
		className?: string;
		gap?: string;
		height?: string;
	}

	let { className = 'h-full w-full', gap = 'gap-4', height = 'h-12' }: Props = $props();
</script>

<div class="flex items-center {className} {gap} justify-center">
	<div class="rotate-45 {height}">
		<ArrowUp rotate />
	</div>
	<div class="-rotate-45 {height}">
		<ArrowUp rotate />
	</div>
</div>
